import {ExcelApi, GetMacroDiffRequest, GetSheetDiffRequest} from 'hemwb-api';
import {configuration} from '../getBackendConfiguration';

const excelApi = new ExcelApi(configuration);

export const requestContentList = (itemUUID: string) => excelApi.getWorkbookContentList({itemUUID});
export const requestSheetDiff = (param: GetSheetDiffRequest) => excelApi.getSheetDiff(param);
export const requestMacroDiff = (param: GetMacroDiffRequest) => excelApi.getMacroDiff(param);
